import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@mgc/react-components';
import MapPropTypes from '../../MapPropTypes';
import ModalBase from '../Base';
import strings from '../../../strings';
import utils from '../../../utils';

export default class OrderCancelModal extends Component {
    static propTypes = {
        visible: PropTypes.bool.isRequired,
        close: PropTypes.func.isRequired,
        transaction: MapPropTypes.TransactionProps,
        cancelOrder: PropTypes.func.isRequired,
    };

    render() {
        if (!this.props.transaction) {
            return null;
        }

        const description = [
            {
                label: strings.description,
                value: this.props.transaction.description,
            },
            {
                label: strings.orderedOn,
                value: utils.formatDate(this.props.transaction.lastModified),
            },
            {
                label: strings.fulfilledOn,
                value: this.props.transaction.batchTimestamp ? (
                    utils.formatDate(this.props.transaction.batchTimestamp)
                ) : (
                    <span className="text-mute">{strings.notFulfilled}</span>
                ),
            },
            {
                label: strings.confirmation,
                value: this.props.transaction.confirmation,
            },
            {
                label: strings.amount,
                value: utils.formatPrice(this.props.transaction.amount),
            },
        ];

        return (
            <ModalBase
                modalClassName="cancel-order-modal"
                modalTitle={
                    <span>
                        <span className="text-warning">
                            <Icon name="icon-warning2" />{' '}
                        </span>
                        {strings.reallyCancel}
                    </span>
                }
                visible={this.props.visible}
                closeModal={this.props.close}
            >
                <div>
                    <dl className="dl-horizontal">
                        {description.map((item, i) => (
                            <span key={i}>
                                <dt className="col-md-3">{item.label}</dt>
                                <dd className="col-md-9">{item.value}</dd>
                            </span>
                        ))}
                    </dl>
                    <div className="col-md-12 text-right m-b-sm p-a-0">
                        <button
                            onClick={() => this.props.close()}
                            className="btn btn-success m-r-sm"
                        >
                            {strings.no}
                        </button>
                        <button
                            onClick={() =>
                                this.props.cancelOrder(this.props.transaction)
                            }
                            className="btn btn-danger"
                        >
                            {strings.yes}
                        </button>
                    </div>
                </div>
            </ModalBase>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Modals/TransactionModal/OrderCancelModal.jsx